import TextareaAutosize from "react-textarea-autosize";
import styles from "./otherInformationRHF.module.css";

export default function OtherInformationRHF({ mode, register, newData }) {
  return mode === "add" ? (
    <div className={styles["content-container"]}>
      <p className={styles["container-description"]}>Иные сведения</p>
      <label className={styles["label"]}>
        {"Информация о хозяйственном ведении и оперативном управлении"}
      </label>
      <TextareaAutosize
        id={"note"}
        className={styles["form-textarea"]}
        placeholder={"Введите"}
        {...register("note")}
      />
      <p className={styles["description-text"]}>
        {`Сведения о том, находится ли маломерное судно в хозяйственном ведении или оперативном
          управлении (если находится, то указать наименование, местонахождение, учетный номер
          плательщика, контактный номер юридического лица)`}
      </p>
      <label className={styles["label"]}>{"Информация об аренде и лизинге"}</label>
      <TextareaAutosize
        id={"note2"}
        className={styles["form-textarea"]}
        placeholder={"Введите"}
        {...register("note2")}
      />
      <p className={styles["description-text"]}>
        {`Сведения о том, передано ли маломерное судно в аренду, лизинг (если передано, то указать
          фамилию, собственное имя, отчество (если такое имеется), идентификационный номер, серию (при
          наличии), номер, кем и когда выдан документ, удостоверяющий личность, адрес местожительства,
          контактный телефон — если арендатор, лизингополучатель - физическое лицо; наименование,
          местонахождение, учетный номер плательщика, контактны телефон — если арендатор,
          лизингополучатель — юридическое лицо; фамилию, собственное имя, отчество (если таковое
          имеется), идентификационный номер, серию (при наличии), номер, кем и когда выдан документ,
          удостоверяющий личность, адрес места жительства, учетный номер плательщика, контактный
          телефон — если арендатор, лизингополучатель — индивидуальный предприниматель)`}
      </p>
    </div>
  ) : null;
}
